import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/footer'
import services from '../assets/about2.jpg'
import { Link } from 'react-router-dom'

class Services extends React.Component{
    render(){
        return(
            <div>
                <Helmet>
                    <title>Amit Paintings - Services We Offer</title>
                </Helmet>
                <section className="md:px-10 px-2 py-2 md:py-5 bg-white border-b-4">
                    <div className="grid grid-cols-12 pb-10 gap-6 flex items-center">
                        <div className="col-span-12 md:col-span-6">
                            <h5 className="uppercase font-semibold text-ap">Services</h5>
                            <hr className="border-pink-600 border-2 my-3 w-2/12" />
                            <h1 className="text-3xl font-bold leading-tight mb-5">Services - Amit Paintings.com</h1>
                            <p className="leading-loose">At Amit Paintings, we offer residential and commercial paintings in across India. Residential house painting includes interior and exterior painting, Ceiling painting, Stencil and texture painting. We undertake end to end services and the customer just has to sit and relax. Commercial painting services include office, shops, tech parks, malls etc. </p>
                            <ul className="mb-10 mt-5 list-disc list-inside ml-5">
                                <li>Residential Services</li>
                                <li>Consultation Services</li>
                                <li>Hospitality Services</li>
                                <li>Commercial Services</li>
                                <li>Industrial Services</li>
                                <li>Water Proofing Services</li>
                            </ul>
                            <Link to="/contact-us" className="bg-ap text-white px-10 py-3 mx-auto rounded hover:bg-black">Schedule Free Visit</Link>
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <img alt="amit paintings" src={services} className="w-full" />
                        </div>
                    </div>
                </section>

            
                <Footer/>
            </div>
        )
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/pages/services.jsx